import { Text, VStack, Grid, GridItem, HStack, Box } from "@chakra-ui/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import InnerHtml from "./innerHtml"
library.add(fas)
const camelToDash = (str:string) =>{
    return str.replace(/([A-Z])/g, function($1){return "-"+$1.toLowerCase();});
  }

const ConteudoIcone2 = (props:any) => {
    const { data } = props
    const camelIcon = camelToDash(data.Icone)
    let iconName:any = camelIcon.split('-')
    // remove o primeiro item
    iconName.shift()
    // remove o segundo item
    iconName.shift()
    // remove o terceiro item
    if (iconName[0]=='reg') iconName.shift()
    iconName = iconName.join('-')
    const Center = () => {
        return (
            <VStack className="ConteudoIcone1-vstack" gap={2}>
                <FontAwesomeIcon style={{fontSize:72}} className="ConteudoIcone2-icone" color="rgb(204,0,0)" icon={iconName} />
                <Text className="ConteudoIcone2-titulo" fontWeight={'bold'} fontSize={22}>{data?.Titulo}</Text>
                <InnerHtml className="ConteudoIcone2-descricao" fontSize={14} html={data?.Descricao} />
            </VStack>
        )
    }

    const Left = () => {
        return (
            <HStack className="ConteudoIcone1-hstack" gap={2}>
                <FontAwesomeIcon style={{fontSize:72}} color="rgb(204,0,0)" icon={iconName} />
                <VStack className="ConteudoImg1-vstack" gap={2} marginStart={5}>
                    <Text className="ConteudoIcone2-titulo" fontWeight={'bold'} fontSize={22} w={'100%'}>{data?.Titulo}</Text>
                    <Text className="ConteudoIcone2-descricao" fontSize={14}>{data?.Descricao}</Text>
                </VStack>
            </HStack>
        )
    }

    const Right = () => {
        return (
            <HStack className="ConteudoIcone1-hstack" gap={2}>
                <VStack className="ConteudoIcone1-vstack" gap={2} marginEnd={5}>
                    <Text className="ConteudoIcone2-titulo" fontWeight={'bold'} fontSize={22} w={'100%'} textAlign={'end'}>{data?.Titulo}</Text>
                    <Text className="ConteudoIcone2-descricao" fontSize={14} textAlign={'end'}>{data?.Descricao}</Text>
                </VStack>
                <FontAwesomeIcon style={{fontSize:72}} color="rgb(204,0,0)" icon={iconName} />
            </HStack>
        )
    }
    
    return (
        <Box as={'section'} pos={'relative'} bg={'gray.200'} p={2} 
            className={data?.ClassName} gap={10} w={'md'}>
            {data?.Alinhamento === 'Centro' && <Center />}
            {data?.Alinhamento === 'Esquerda' && <Left />}
            {data?.Alinhamento === 'Direita' && <Right />}
        </Box>
    )
}

export default ConteudoIcone2
